import { axiosInstance, BASE_URLS } from "@/src/shared/api";

interface ConsultationRequestForm {
    orderNumber: string;
    phoneNumber: string;
    productName: string;
}

export const sendConsultationRequestForm = async (payload: ConsultationRequestForm): Promise<boolean> => {
    try {
        const formData = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
            formData.append(key, value as string);
        });

        const response = await axiosInstance.post(
            `${BASE_URLS.CONSULTATION_REQUEST}`,
            formData,
            {
                headers: { "Content-Type": "application/json" },
            },
        );
        return response.data;
    } catch (error: any) {
        console.error(
            "error",
            "[sendConsultationRequestForm] Error while sending consultation request form",
            {
                url: error?.config?.url,
                meta: error?.response?.data,
            },
        );
        throw error;
    }
};
